import { toRem } from '@nxtpeople/nxt-vue-library';
import { createStore } from 'vuex';
import modules from './collections';
import { StoreState } from './models/store.interface';

const store = createStore<StoreState>({
   state: {
      users_with_super_permissions: [
         'info@nxtpeople.com',
         'kristof.desmedt@nxtpeople.com',

         // nxtplay
         'caitlin.messeeuw@nxtpeople.com',
         'kjell.kind@ago.jobs',
         'kjell.kind@nxtpeople.com',
         'michiel.breughe@nxtpeople.com',

         // cst
         'noura.el.kaddouri@nxtpeople.com',
         'sarah.coopman@nxtpeople.com',
         'yentl.stroom@nxtpeople.com',
      ],
      tenants_with_unlimited_sms: [63], // 63 = Westvlees
      notifications: [],
      history: [],
      times_route_changed_previous_page: [],
      prevent_modal_data: {
         title: 'global.close_dirty_modal',
         cancelText: 'actions.cancel_continue_edit',
         discardText: 'actions.close_no_save',
         width: toRem(350),
         height: toRem(125) + '!important',
      },
   },
   getters: {},
   mutations: {
      pushNotification(state, notification) {
         state.notifications.push(notification);
      },
      removeNotification(state, notificationToRemove) {
         const INDEX_OF_NOTIFICATION = state.notifications.findIndex((notification) => notification.id == notificationToRemove.id);
         if (INDEX_OF_NOTIFICATION < 0) return;

         state.notifications.splice(INDEX_OF_NOTIFICATION, 1);
      },
      UPDATE_NOTIFICATION_BY_INDEX(state, { new_notification, index }) {
         state.notifications[index] = { ...state.notifications[index], ...new_notification };
      },
   },
   actions: {
      async addNotification(context, { notification }) {
         const NEW_NOTIFICATION = {
            ...notification,
            duration: notification?.duration ? notification.duration : 5000,
            id: notification?.id ?? (Math.random().toString(36) + Date.now().toString(36)).substr(2),
         };

         context.commit('pushNotification', NEW_NOTIFICATION);
         return NEW_NOTIFICATION;
      },
      async removeNotification(context, { notification }) {
         context.commit('removeNotification', notification);
      },
   },
   modules: modules,
});

export default store;
